"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _get = _interopRequireDefault(require("lodash/get"));

var _PriceAttributesAggregatorByRuleSet = _interopRequireDefault(require("./PriceAttributesAggregatorByRuleSet"));

var _Loading = _interopRequireDefault(require("./Loading"));

var _constants = _interopRequireDefault(require("./constants"));

var _commonUtils = require("./commonUtils");

var _services = require("./services");

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var cancelableRuleSetPromise;

var PriceAttributesAggregator =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(PriceAttributesAggregator, _PureComponent);

  function PriceAttributesAggregator(_props) {
    var _this;

    (0, _classCallCheck2["default"])(this, PriceAttributesAggregator);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PriceAttributesAggregator).call(this, _props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getAndSetRuleSetByReferenceId", function () {
      var _this$props = _this.props,
          referenceId = _this$props.referenceId,
          authToken = _this$props.authToken;
      cancelableRuleSetPromise = (0, _services.makeCancelable)((0, _services.getRuleSet)(referenceId, authToken));
      cancelableRuleSetPromise.promise.then(function (ruleSets) {
        if ((0, _isEmpty["default"])(ruleSets)) {
          _this.setState({
            error: "Not able to get rule set for provided reference id: ".concat(referenceId),
            isLoading: false
          });
        } else {
          _this.setState({
            ruleSet: (0, _commonUtils.getAuthoritativeRuleSet)(ruleSets),
            isLoading: false,
            error: null
          });
        }
      })["catch"](function (error) {
        _this.setState({
          error: error.toString(),
          isLoading: false
        });
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "haveSameKeys", function (pivotConfiguration, prunedPivotConfiguration) {
      if (!pivotConfiguration && prunedPivotConfiguration || pivotConfiguration && !prunedPivotConfiguration || pivotConfiguration.length !== prunedPivotConfiguration.length) {
        return false;
      }

      var result = true;
      pivotConfiguration.forEach(function (attribute) {
        if (!prunedPivotConfiguration.find(function (item) {
          return item.key === attribute.key;
        })) {
          result = false;
        }
      });
      return result;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updatePivotAttributes", function (pivotConfiguration) {
      var updatedPivotConfiguration = _this.prunePivotConfiguration(pivotConfiguration);

      var oldPivotConfiguration = _this.state.updatedPivotConfiguration;
      var _this$state = _this.state,
          prunedPivotConfiguration = _this$state.prunedPivotConfiguration,
          backupAttributeSelections = _this$state.backupAttributeSelections;

      _this.setState({
        pivotConfiguration: pivotConfiguration,
        updatedPivotConfiguration: updatedPivotConfiguration,
        isPivotingPruned: true
      }, function () {
        if (!_this.haveSameKeys(updatedPivotConfiguration, prunedPivotConfiguration)) {
          var initialAttributeSelections = backupAttributeSelections || _this.state.initialAttributeSelections;

          _this.setState({
            prunedPivotConfiguration: updatedPivotConfiguration,
            initialAttributeSelections: initialAttributeSelections
          });
        }

        if (!(0, _isEqual["default"])(updatedPivotConfiguration, oldPivotConfiguration)) {
          _this.callUpdatePivotAttributes(updatedPivotConfiguration);
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updatePivotValues", function (label, selectedValues) {
      var _this$state2 = _this.state,
          selectedRow = _this$state2.selectedRow,
          selectedColumn = _this$state2.selectedColumn;

      if (selectedRow && label === selectedRow.label) {
        selectedRow = _objectSpread({}, selectedRow, {
          selectedValues: selectedValues
        });
      }

      if (selectedColumn && label === selectedColumn.label) {
        selectedColumn = _objectSpread({}, selectedColumn, {
          selectedValues: selectedValues
        });
      }

      _this.setState({
        selectedRow: selectedRow,
        selectedColumn: selectedColumn
      }, function () {
        return _this.updatePivotConfiguration();
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "callUpdatePivotAttributes", function (pivotConfiguration) {
      if (_this.ref.current) {
        _this.ref.current.updatePivotAttributes(pivotConfiguration);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "normalizeResolvedAttributes", function (resolvedAttributes) {
      return resolvedAttributes.forEach(function (_ref) {
        var values = _ref.values;
        values.forEach(function (row) {
          var attributes = row.attributes;
          var v1Attributes = [];
          attributes.forEach(function (attribute) {
            var classes = attribute.classes,
                attributeKey = attribute.key;
            var attributeValue = attribute.resolvedValue;

            if (attributeKey.toLowerCase() === 'country') {
              attributeValue = (0, _commonUtils.getCountryCodeFromCountryName)(attributeValue);
            }

            if (attributeValue) {
              if (classes.length) {
                classes.forEach(function (_ref2) {
                  var name = _ref2.name;
                  v1Attributes.push({
                    "class": name,
                    attributeKey: attributeKey,
                    attributeValue: attributeValue
                  });
                });
              } else {
                v1Attributes.push({
                  "class": 'tenant',
                  attributeKey: attributeKey,
                  attributeValue: attributeValue
                });
              }
            }
          });
          row.attributes = v1Attributes;
        });
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFullyResolved", function (resolvedAttributes, requiredAttributes, displayedAttributes) {
      var allAttributesFilled = true;
      var attributesArray = (0, _get["default"])(resolvedAttributes, '[0].values[0].attributes');

      if (attributesArray && attributesArray.find(function (each) {
        return each.isDisplayed && !each.resolvedValue;
      })) {
        allAttributesFilled = false;
      }

      if (allAttributesFilled) {
        var _this$state3 = _this.state,
            pivotConfiguration = _this$state3.pivotConfiguration,
            isPivotingPruned = _this$state3.isPivotingPruned;
        var _this$state4 = _this.state,
            selectedRow = _this$state4.selectedRow,
            selectedColumn = _this$state4.selectedColumn;

        if (isPivotingPruned && pivotConfiguration.length) {
          pivotConfiguration.forEach(function (attribute) {
            attribute.pivotValues = attribute.selectedValues;
          });

          _this.setState({
            isPivotingPruned: false
          }, function () {
            return _this.callUpdatePivotAttributes(pivotConfiguration);
          });
        } else {
          _this.setState({
            backupAttributeSelections: attributesArray
          });

          _this.normalizeResolvedAttributes(resolvedAttributes);

          var state = _constants["default"].FULLY_RESOLVED;

          _this.setState({
            resolvedAttributes: resolvedAttributes,
            requiredAttributes: requiredAttributes
          });

          _this.onChange({
            resolvedAttributes: resolvedAttributes,
            requiredAttributes: requiredAttributes,
            displayedAttributes: displayedAttributes,
            state: state,
            selectedRow: selectedRow,
            selectedColumn: selectedColumn
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onPartiallyResolved", function (resolvedAttributes, requiredAttributes, displayedAttributes) {
      var _this$state5 = _this.state,
          pivotConfiguration = _this$state5.pivotConfiguration,
          isPivotingPruned = _this$state5.isPivotingPruned,
          selectedRow = _this$state5.selectedRow,
          selectedColumn = _this$state5.selectedColumn;
      var state = _constants["default"].PARTIALLY_RESOLVED;

      _this.setState({
        backupAttributeSelections: (0, _get["default"])(resolvedAttributes, '[0].values[0].attributes')
      });

      if (!isPivotingPruned) {
        _this.setState({
          isPivotingPruned: true
        }, function () {
          return _this.updatePivotAttributes(pivotConfiguration);
        });
      } else {
        _this.normalizeResolvedAttributes(resolvedAttributes);

        _this.onChange({
          resolvedAttributes: resolvedAttributes,
          requiredAttributes: requiredAttributes,
          displayedAttributes: displayedAttributes,
          state: state,
          selectedRow: selectedRow,
          selectedColumn: selectedColumn
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onReset", function () {
      var _this$state6 = _this.state,
          selectedRow = _this$state6.selectedRow,
          selectedColumn = _this$state6.selectedColumn;
      var state = 'onLoad';

      if (!_this.state.isPivotingPruned) {
        _this.setState({
          isPivotingPruned: true,
          initialAttributeSelections: []
        }, function () {
          return _this.onChange({
            state: state,
            selectedRow: selectedRow,
            selectedColumn: selectedColumn
          });
        });
      } else {
        _this.onChange({
          state: state,
          selectedRow: selectedRow,
          selectedColumn: selectedColumn
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onError", function () {
      _this.props.onChange({
        state: 'error'
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "prunePivotConfiguration", function (pivotConfiguration) {
      if (Array.isArray(pivotConfiguration)) {
        var prunedPivotConfiguration = [];
        pivotConfiguration.forEach(function (attribute) {
          var key = attribute.key,
              selectedValues = attribute.selectedValues;
          prunedPivotConfiguration.push({
            key: key,
            "class": attribute["class"],
            pivotValues: Array.isArray(selectedValues) && selectedValues.length && [selectedValues[0]],
            selectedValues: selectedValues
          });
        });
        return prunedPivotConfiguration;
      }

      return [];
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setPageLoadedState", function () {
      var ruleSet = _this.props.ruleSet;

      _this.setState({
        ruleSet: ruleSet,
        isLoading: false,
        error: null
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "init", function () {
      var _this$props2 = _this.props,
          consumerId = _this$props2.consumerId,
          referenceId = _this$props2.referenceId,
          ruleSet = _this$props2.ruleSet,
          pivotConfiguration = _this$props2.pivotConfiguration,
          initialAttributeSelections = _this$props2.initialAttributeSelections,
          initialPivotingSelections = _this$props2.initialPivotingSelections;

      var prunedPivotConfiguration = _this.prunePivotConfiguration(pivotConfiguration);

      _this.onRowSelectionChange(initialPivotingSelections && initialPivotingSelections.firstAttribute ? initialPivotingSelections.firstAttribute : undefined);

      _this.onColumnSelectionChange(initialPivotingSelections && initialPivotingSelections.secondAttribute ? initialPivotingSelections.secondAttribute : undefined);

      _this.setState({
        initialAttributeSelections: initialAttributeSelections,
        pivotConfiguration: pivotConfiguration,
        isPivotingPruned: true,
        prunedPivotConfiguration: prunedPivotConfiguration,
        updatedPivotConfiguration: prunedPivotConfiguration,
        resolvedAttributes: undefined,
        requiredAttributes: undefined
      });

      if ((0, _isEmpty["default"])(consumerId) || !(0, _isEmpty["default"])(referenceId) && !(0, _isEmpty["default"])(ruleSet)) {
        _this.setPageLoadedState();
      } else if (!(0, _isEmpty["default"])(referenceId)) {
        _this.getAndSetRuleSetByReferenceId();
      } else {
        _this.setPageLoadedState();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isInvalid", function (props) {
      var consumerId = props.consumerId,
          referenceId = props.referenceId,
          ruleSet = props.ruleSet,
          customRequiredAttributes = props.customRequiredAttributes;

      if ((0, _isEmpty["default"])(consumerId)) {
        return (0, _commonUtils.getNotificationAlert)("Please provide consumer id by passing prop 'consumerId' to the component", 'info');
      } else if ((0, _isEmpty["default"])(referenceId) && (0, _isEmpty["default"])(ruleSet) && (0, _isEmpty["default"])(customRequiredAttributes)) {
        return (0, _commonUtils.getNotificationAlert)('Please provide valid referenceId or ruleSet or customRequiredAttributes in props', 'info');
      } else if (!(0, _isEmpty["default"])(referenceId) && !(0, _isEmpty["default"])(ruleSet)) {
        return (0, _commonUtils.getNotificationAlert)('Please provide only the ruleSet or the referenceId in props', 'info');
      }

      return null;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getHiddenAttributes", function () {
      var updatedPivotConfiguration = _this.state.updatedPivotConfiguration;

      if (updatedPivotConfiguration) {
        var hiddenAttributes = [];
        updatedPivotConfiguration.forEach(function (attribute) {
          hiddenAttributes.push({
            attributeKey: attribute.key,
            "class": attribute["class"]
          });
        });
        return hiddenAttributes;
      }

      return undefined;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updatePivotConfiguration", function () {
      var _this$state7 = _this.state,
          resolvedAttributes = _this$state7.resolvedAttributes,
          requiredAttributes = _this$state7.requiredAttributes,
          selectedRow = _this$state7.selectedRow,
          selectedColumn = _this$state7.selectedColumn;
      var pivotConfiguration = [];

      if (selectedRow) {
        pivotConfiguration.push(selectedRow);
      }

      if (selectedColumn) {
        pivotConfiguration.push(selectedColumn);
      }

      _this.updatePivotAttributes(pivotConfiguration);

      _this.onChange({
        resolvedAttributes: resolvedAttributes,
        requiredAttributes: requiredAttributes,
        selectedRow: selectedRow,
        selectedColumn: selectedColumn,
        state: _constants["default"].ON_LOAD
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (_ref3) {
      var resolvedAttributes = _ref3.resolvedAttributes,
          requiredAttributes = _ref3.requiredAttributes,
          displayedAttributes = _ref3.displayedAttributes,
          selectedRow = _ref3.selectedRow,
          selectedColumn = _ref3.selectedColumn,
          state = _ref3.state;

      if (!selectedRow && selectedColumn) {
        selectedRow = selectedColumn;
        selectedColumn = undefined;
      } else if (!selectedRow && !selectedColumn) {
        var attributesArray = (0, _get["default"])(resolvedAttributes, '[0].values[0].attributes');
        var quantityAttribute = attributesArray && attributesArray.find(function (attribute) {
          return attribute.attributeKey && attribute.attributeKey.toLowerCase() === 'quantity';
        });

        if (quantityAttribute && quantityAttribute.attributeValue) {
          selectedRow = {
            key: 'Quantity',
            label: 'Quantity',
            value: 'Quantity',
            selectedValues: [quantityAttribute.attributeValue]
          };
        }
      }

      _this.props.onChange({
        resolvedAttributes: resolvedAttributes,
        requiredAttributes: requiredAttributes,
        displayedAttributes: displayedAttributes,
        selectedRow: selectedRow,
        selectedColumn: selectedColumn,
        state: state
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onRowSelectionChange", function (selectedRow) {
      selectedRow = (0, _cloneDeep["default"])(selectedRow);
      var _this$state8 = _this.state,
          resolvedAttributes = _this$state8.resolvedAttributes,
          requiredAttributes = _this$state8.requiredAttributes,
          selectedColumn = _this$state8.selectedColumn,
          oldRow = _this$state8.selectedRow;
      var state = _constants["default"].ON_LOAD;

      if (!oldRow || !selectedRow || selectedRow.key !== oldRow.key || JSON.stringify(selectedRow.selectedValues) !== JSON.stringify(oldRow.selectedValues)) {
        _this.setState({
          selectedRow: selectedRow
        }, function () {
          _this.updatePivotConfiguration();

          _this.onChange({
            resolvedAttributes: resolvedAttributes,
            requiredAttributes: requiredAttributes,
            selectedRow: selectedRow,
            selectedColumn: selectedColumn,
            state: state
          });
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onColumnSelectionChange", function (selectedColumn) {
      selectedColumn = (0, _cloneDeep["default"])(selectedColumn);
      var _this$state9 = _this.state,
          resolvedAttributes = _this$state9.resolvedAttributes,
          requiredAttributes = _this$state9.requiredAttributes,
          selectedRow = _this$state9.selectedRow,
          oldColumn = _this$state9.selectedColumn;
      var state = _constants["default"].ON_LOAD;

      if (!oldColumn || !selectedColumn || selectedColumn.key !== oldColumn.key || JSON.stringify(selectedColumn.selectedValues) !== JSON.stringify(oldColumn.selectedValues)) {
        _this.setState({
          selectedColumn: selectedColumn
        }, function () {
          _this.updatePivotConfiguration();

          _this.onChange({
            resolvedAttributes: resolvedAttributes,
            requiredAttributes: requiredAttributes,
            selectedRow: selectedRow,
            selectedColumn: selectedColumn,
            state: state
          });
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggleExpanded", function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    });
    _this.ref = _react["default"].createRef();
    _this.state = {
      ruleSet: _props.ruleSet,
      isLoading: true,
      error: null
    };
    return _this;
  }

  (0, _createClass2["default"])(PriceAttributesAggregator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          initialAttributeSelections = _this$props3.initialAttributeSelections,
          consumerId = _this$props3.consumerId,
          referenceId = _this$props3.referenceId,
          ruleSet = _this$props3.ruleSet,
          pivotConfiguration = _this$props3.pivotConfiguration,
          authToken = _this$props3.authToken,
          initialPivotingSelections = _this$props3.initialPivotingSelections;

      if (!(0, _isEqual["default"])(prevProps.consumerId, consumerId) || !(0, _isEqual["default"])(prevProps.referenceId, referenceId) || !(0, _isEqual["default"])(prevProps.ruleSet, ruleSet) || !(0, _isEqual["default"])(prevProps.pivotConfiguration, pivotConfiguration) || !(0, _isEqual["default"])(prevProps.initialPivotingSelections, initialPivotingSelections) || prevProps.authToken !== authToken) {
        this.init();
      }

      if (!(0, _isEqual["default"])(prevProps.initialAttributeSelections, initialAttributeSelections)) {
        this.setState({
          initialAttributeSelections: initialAttributeSelections
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _commonUtils.cancelPromise)(cancelableRuleSetPromise);
    }
  }, {
    key: "render",
    value: function render() {
      var isInvalid = this.isInvalid(this.props);

      if (isInvalid) {
        return isInvalid;
      }

      var _this$state10 = this.state,
          isLoading = _this$state10.isLoading,
          ruleSet = _this$state10.ruleSet,
          error = _this$state10.error,
          prunedPivotConfiguration = _this$state10.prunedPivotConfiguration,
          updatedPivotConfiguration = _this$state10.updatedPivotConfiguration,
          selectedRow = _this$state10.selectedRow,
          selectedColumn = _this$state10.selectedColumn,
          initialAttributeSelections = _this$state10.initialAttributeSelections;
      var showPivotConfig = this.props.showPivotConfig;
      var hiddenAttributes = this.getHiddenAttributes();
      var isPivot = !!(prunedPivotConfiguration && prunedPivotConfiguration.length || updatedPivotConfiguration && updatedPivotConfiguration.length);
      var expanded = this.state.expanded ? this.state.expanded : false;

      if (isLoading) {
        return _react["default"].createElement(_Loading["default"], null);
      }

      return error ? (0, _commonUtils.getNotificationAlert)(error, 'danger') : _react["default"].createElement("div", {
        className: this.props.className
      }, _react["default"].createElement(_PriceAttributesAggregatorByRuleSet["default"], (0, _extends2["default"])({}, this.props, {
        ruleSet: ruleSet,
        isPivot: isPivot,
        hiddenAttributes: hiddenAttributes,
        pivotConfiguration: prunedPivotConfiguration,
        initialAttributeSelections: initialAttributeSelections,
        onFullyResolved: this.onFullyResolved,
        onPartiallyResolved: this.onPartiallyResolved,
        onReset: this.onReset,
        onError: this.onError,
        onRowSelectionChange: this.onRowSelectionChange,
        onColumnSelectionChange: this.onColumnSelectionChange,
        selectedRow: selectedRow,
        selectedColumn: selectedColumn,
        ref: this.ref,
        expanded: expanded,
        toggleExpanded: this.toggleExpanded,
        showPivotConfig: showPivotConfig,
        updatePivotValues: this.updatePivotValues
      })));
    }
  }]);
  return PriceAttributesAggregator;
}(_react.PureComponent);

exports["default"] = PriceAttributesAggregator;
(0, _defineProperty2["default"])(PriceAttributesAggregator, "propTypes", {
  onChange: _propTypes["default"].func.isRequired,
  authToken: _propTypes["default"].string.isRequired,
  consumerId: _propTypes["default"].string.isRequired,
  referenceId: _propTypes["default"].string,
  ruleSet: _propTypes["default"].shape({}),
  customRequiredAttributes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    scope: _propTypes["default"].string.isRequired,
    name: _propTypes["default"].string.isRequired
  })),
  initialAttributeSelections: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  initialPivotingSelections: _propTypes["default"].objectOf(_propTypes["default"].any),
  attributeConfigurations: _propTypes["default"].shape({}),
  hiddenAttributes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    "class": _propTypes["default"].string.isRequired,
    attributeKey: _propTypes["default"].string.isRequired,
    isForceShowIfDerivingAttributes: _propTypes["default"].bool
  })),
  showErrorModal: _propTypes["default"].bool,
  hideDerivedAttributes: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  pivotConfiguration: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  showSelectorPivotUI: _propTypes["default"].bool,
  consumerType: _propTypes["default"].string,
  showAttributeSelectorErrorModal: _propTypes["default"].bool,
  showPivotConfig: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(PriceAttributesAggregator, "defaultProps", {
  referenceId: null,
  ruleSet: null,
  initialAttributeSelections: [],
  attributeConfigurations: {},
  customRequiredAttributes: [],
  hiddenAttributes: [],
  showErrorModal: true,
  hideDerivedAttributes: true,
  className: '',
  pivotConfiguration: [],
  showPivotConfig: false,
  showSelectorPivotUI: false,
  consumerType: 'attributeAggregator'
});